module.exports = __webpack_public_path__ + "media/images/facebook-d8eeb7a21aefde595199dcac1479d71f.png";